import { HeaderLogoComponentModule } from '@1bill-app/components/header-logo/header-logo.module';
import { SharedComponentsModule } from '@1bill-app/components/shared-components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { GetBetterDealsProductsPageRoutingModule } from './get-better-deals-products-routing.module';

import { GetBetterDealsProductsPage } from './get-better-deals-products.page';
import { PopoverBetterDealProductComponent } from '@1bill-app/components/popover/popover-better-deal-product/popover-better-deal-product.component';
import { PopoverBetterDealProductConsentComponent } from '@1bill-app/components/popover/popover-better-deal-product-consent/popover-better-deal-product-consent.component';
import { PopoverBetterDealProductPricingComponent } from '@1bill-app/components/popover/popover-better-deal-product-pricing/popover-better-deal-product-pricing.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    GetBetterDealsProductsPageRoutingModule,
    HeaderLogoComponentModule,
    SharedComponentsModule,
    ReactiveFormsModule, 
  ],
  declarations: [GetBetterDealsProductsPage, PopoverBetterDealProductComponent,PopoverBetterDealProductConsentComponent, PopoverBetterDealProductPricingComponent]
})
export class GetBetterDealsProductsPageModule {}
